import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { convertUSD } from "@revbox/helpers-fe";

function splitDollarValue(value) {
    if (typeof value === 'number' || value === null || value === undefined || value === '') return null;
    const parts = value.split('$');
  
    if (parts.length > 1) {
      return parts[1].split(' ')[0]
    }
  
    return null;
  }

/**
 * @description Render a tooltip with the EUR amount
 * @param {number} eur - The amount in EUR
 * @returns {JSX.Element} The tooltip component
 */

const renderTooltip = (eur) => {
    const condition = eur !== null && eur !== undefined && eur !== '';

    return (
        <Tooltip id="price-tooltip">
            {condition ? `€${eur}` : '-'}
        </Tooltip>
    );
}

/**
 * @description Render a tooltip with the EUR amount
 * @param {JSX.Element} children - The children to render
 * @param {number} eur - The amount in EUR
 * @returns {JSX.Element} The tooltip component
 */

export const OverlayContainer = ({ children, amount, rate }) => {
    let currentAmount = amount;
    const valueFromTaxonomy = splitDollarValue(amount)
    if (valueFromTaxonomy) {
        currentAmount = valueFromTaxonomy
    }

    if (['0.00', '0', '$0.00', '$0', 0, undefined, null].includes(currentAmount) || !rate) {
        return (
            <>
                {children}
            </>
        )
    };
    return (
        <OverlayTrigger
            placement="top"
            overlay={renderTooltip(convertUSD(currentAmount, rate))}
        >
            {children}
        </OverlayTrigger>
    )
}